export { default } from './typography.render';
export * from './typography.scheme';
